import {
  getPostApiV1ThreeLetterCodeClientAdminsShippingAddressConfirmationMutationFetcher,
  getPostApiV1ThreeLetterCodeClientAdminsShippingAddressConfirmationMutationKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import { useMutation } from '@fukuri-admins/hooks/common';
import type { AxiosError } from 'axios';

type Options = {
  /**
   * 確認成功時のコールバック（レスポンスは参照しないため引数なし）
   */
  onSuccess?: () => void;
  /**
   * 確認失敗時のコールバック
   */
  onError?: (error: AxiosError<{ errors?: string[] }>) => void;
};

/**
 * 送付先住所確認 API を実行する mutation hook
 *
 * POST /api/v1/{threeLetterCode}/client_admins/shipping_address_confirmation
 *
 * @param threeLetterCode - 企業コード
 * @param options - onSuccess / onError コールバック
 * @returns useMutation の戻り値（trigger / isMutating 等）
 */
export const usePostShippingAddressConfirmation = (threeLetterCode: string, options?: Options) =>
  useMutation(
    getPostApiV1ThreeLetterCodeClientAdminsShippingAddressConfirmationMutationKey(threeLetterCode),
    getPostApiV1ThreeLetterCodeClientAdminsShippingAddressConfirmationMutationFetcher(
      threeLetterCode
    ),
    options
  );
